<template></template>

<script>
export default {
    mounted() {
        this.load().then(() => {
            if (this.isMobile) {
                this.destroy().then(() => this.observeContainer())
            } else {
                this.boot().then(() => this.observeContainer())
            }
        })

        // this.$inertia.on("navigate", (event) => {
        //     this.boot()
        // })
    },

    data() {
        return {
            containerMounted: false,
            widgetLoaded: false,
        }
    },

    methods: {
        load() {
            window.fwSettings = { widget_id: 73000000018 }
            !(function () {
                if ("function" != typeof window.FreshworksWidget) {
                    var n = function () {
                        n.q.push(arguments)
                    }
                    ;(n.q = []), (window.FreshworksWidget = n)
                }
            })()
            return new Promise((resolve) => {
                if (document.getElementById("freshworks-script")) {
                    return
                }
                let src = "https://widget.freshworks.com/widgets/73000000018.js"
                let script = document.createElement("script")
                script.setAttribute("src", src)
                script.setAttribute("defer", "defer")
                script.setAttribute("async", "async")
                script.setAttribute("type", "text/javascript")
                script.setAttribute("id", "freshworks-script")
                document.body.appendChild(script)
                this.widgetLoaded = true
                resolve()
            })
        },

        observeContainer() {
            let observer = new MutationObserver(() => {
                if (!this.containerMounted && document.body.contains(document.querySelector("#freshworks-container"))) {
                    this.containerMounted = true
                    this.observeWidget()
                }
            })
            observer.observe(document.documentElement || document.body, { childList: true, subtree: true })
        },

        observeWidget() {
            let in_dom = document.body.contains(document.querySelector("#freshworks-frame-wrapper"))
            let observer = new MutationObserver(() => {
                if (document.body.contains(document.querySelector("#freshworks-frame-wrapper"))) {
                    if (!in_dom) {
                        //
                    }
                    in_dom = true
                } else if (in_dom) {
                    in_dom = false
                }
            })
            observer.observe(document.querySelector("#freshworks-container"), { childList: true, subtree: true })
        },

        boot() {
            return new Promise((resolve) => {
                if (!this.widgetLoaded) {
                    FreshworksWidget("boot")
                }
                if (this.$page.props.user) {
                    FreshworksWidget("identify", "ticketForm", {
                        name: this.$page.props.user.name,
                        email: this.$page.props.user.email,
                    })
                }
                FreshworksWidget("hide", "ticketForm", ["subject"])
                this.widgetLoaded = true
                resolve()
            })
        },

        destroy() {
            return new Promise((resolve) => {
                FreshworksWidget("destroy")
                this.widgetLoaded = false
                resolve()
            })
        },

        open() {
            if (!this.widgetLoaded) {
                this.boot().then(() => {
                    FreshworksWidget("open")
                })
            } else {
                FreshworksWidget("open")
            }
        },
    },
}
</script>
